<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1>{{ title || 'Jetzt antworten' }}</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="closeFan">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main ref="main" class="scrollbar-check">
			<Loading v-if="loadingMessage" text="Lade Nachricht..."/>
			<template v-else>
				<div v-if="loadingMessageUnsuccessful">
					<JonInfo>
						<template #message>
							<p class="font-weight-bold">
								Diese Nachricht ist nicht (mehr) verfügbar. Möglicherweise ist sie bereits nicht mehr
								aktuell.
							</p>
							<p>Nach Schließen der Maske aktualisiert sich die Nachrichtenliste automatisch.</p>
						</template>
					</JonInfo>
				</div>
				<template v-else>
					<!--<InfoLine
						v-if="localMessage.appointment && localMessage.appointment.accessLink"
						label="Zugangsdaten"
						:text="localMessage.appointment.accessLink"
						link
					/>-->
					<!--<template v-if="isRecipientTypeApplicant">
						<InfoLine
							label="Firma"
							:text="localMessage.customer.companyName"
						/>
						<InfoLine
							label="Person"
							:text="localMessage.customer.nameWithSalutation"
							class="bg-color-light-gray"
						/>

					</template>
					<template v-if="isRecipientTypeCustomer">
						<InfoLine
							v-if="localMessage.disclosedData"
							label="Person"
							:text="localMessage.disclosedData.nameWithSalutation"
						/>
						<InfoLine
							v-else
							label="Person"
							:text="localMessage.pseudonym.label"
						/>
					</template>-->
					<ApplicantIsInterestedToo
						v-if="isApplicantIsInterestedToo"
						:message="localMessage"
						:declined-vita="isApplicantDeclinedVita"
						:sent-vita="isApplicantSentVita"
						class="mt-4"
						@processed="onProcessed"
						@cancel="closeFan"
					/>
					<div v-if="matchingEligible" class="mt-5">
						<Matching
							:job-profile-id="localMessage.jobProfile.id"
							:job-id="localMessage.job.id"
							@loaded="loadedMatching = true"
						/>
					</div>
					<div v-if="loadedMatching || loadedVita" class="mt-5">
						<CustomerIsInterested
							v-if="showCustomerIsInterested"
							ref="customerIsInterested"
							:message="localMessage"
							@contentGrow="onContentGrow"
							@processed="onProcessed"
							@loading="customerIsInterestedLoading = $event"
							@sendoffDataChanged="customerIsInterestedSendoffData = $event"
						/>
					</div>
					<ApplicantIsInterested
						v-if="localMessage.conversationStatus.id === conversationStatusList.applicantIsInterested"
						:message="localMessage"
						class="mt-5"
						@processed="onProcessed"
					/>
					<CustomerSentAppointmentToApplicant
						v-if="shouldShowCustomerSendAppointmentToApplicant"
						:message="localMessage"
						@processed="onProcessed"
					/>
					<CustomerNewAppointmentDates
						v-if="shouldShowCustomerNewAppointmentDates"
						:message="localMessage"
						@processed="onProcessed"
					/>
					<CustomerPostAppointment
						v-if="shouldShowCustomerPostAppointment"
						:message="localMessage"
						:force-took-place="customerPostAppointmentForceTookPlace"
						class="mt-5"
						@processed="onProcessed"
					/>
					<ApplicantPostAppointment
						v-if="shouldShowApplicantPostAppointment"
						:message="localMessage"
						class="mt-5"
						@processed="onProcessed"
					/>
					<ApplicantAlternativeAppointmentPossibleForCustomer
						v-if="shouldShowApplicantAlternativeAppointmentPossibleForCustomer"
						:message="localMessage"
						class="mt-5"
						@processed="onProcessed"
					/>
					<Collaboration
						v-if="shouldShowCollaboration"
						:message="localMessage"
						class="mt-5"
						@processed="onProcessed"
					/>
					<CollaborationAccept
						v-if="shouldShowCollaborationAccept"
						:message="localMessage"
						class="mt-5"
						@processed="onProcessed"
					/>
					<!--<MarkAsRead
						v-if="shouldShowMarkAsRead"
						:message="localMessage"
						class="mt-5"
						@processed="onProcessed"
					/>-->
				</template>
			</template>
		</main>
		<footer v-if="showCustomerIsInterested">
			<template v-if="footerLayout === footerLayouts.customerIsInterestedInterested">
				<div class="flex-grow-1 mr-2">
					<Button
						text="Kontaktanfrage bestätigen"
						icon="checkmark"
						class="mr-md-4"
						:disabled="customerIsInterestedLoading"
						:loading="customerIsInterestedLoading"
						@click="customerIsInterestedClickedConfirm"
					/>
					<a
						v-if="!customerIsInterestedLoading"
						href="#"
						class="d-inline-block mt-2 mt-md-0"
						@click.prevent="customerIsInterestedClickedInterestedCustomerUninteresting"
					>
						Arbeitgeber nicht interessant
					</a>
				</div>
				<div v-if="!customerIsInterestedLoading" class="mt-2 mt-md-0">
					<a href="#" @click.prevent="customerIsInterestedInterestedRevert">Zurück</a>
				</div>
			</template>
			<template v-else-if="footerLayout === footerLayouts.customerIsInterestedCustomerUninteresting">
				<div class="flex-grow-1 mr-2">
					<Button
						text="Verabschiedung senden"
						icon="close"
						:loading="customerIsInterestedLoading"
						:disabled="!customerIsInterestedCustomerUninterestingValid || customerIsInterestedLoading"
						@click="customerIsInterestedClickedConfirm"
					/>
				</div>
				<div v-if="!customerIsInterestedLoading">
					<a href="#" @click.prevent="customerIsInterestedClickedInterestedCustomerUninterestingRevert">Zurück</a>
				</div>
			</template>
			<template v-else-if="footerLayout === footerLayouts.customerIsInterestedNotInterested">
				<div class="flex-grow-1 mr-2">
					<Button
						text="Verabschiedung senden"
						icon="close"
						class="mt-3"
						:disabled="customerIsInterestedLoading"
						:loading="customerIsInterestedLoading"
						@click="customerIsInterestedClickedConfirm"
					/>
				</div>
				<div v-if="!customerIsInterestedLoading">
					<a href="#" @click.prevent="customerIsInterestedClickedNotInterestedRevert">Zurück</a>
				</div>
			</template>
			<template v-else>
				<div class="flex-grow-1 mr-2">
					<Button
						text="Job interessant"
						success
						icon="checkmark"
						@click="customerIsInterestedClickedInterested"
					/>
				</div>
				<div>
					<Button
						text="Job nicht interessant"
						secondary
						icon="close"
						class="ml-md-5 mt-2 mt-md-0"
						@click="customerIsInterestedClickedNotInterested"
					/>
				</div>
			</template>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import ArrowLink from "@/vue/common/ArrowLink";
import Matching from "@/vue/application/job/matching/Matching";
import PopUp from "@/vue/common/PopUp";
import InfoLine from "@/vue/communication/conversation/message/reply/InfoLine";
import CustomerSentAppointmentToApplicant
	from "@/vue/communication/conversation/message/reply/CustomerSentAppointmentToApplicant";
import ApplicantPostAppointment from "@/vue/communication/conversation/message/reply/ApplicantPostAppointment";
import CustomerIsInterested from "@/vue/communication/conversation/message/reply/CustomerIsInterested";
import ApplicantIsInterestedToo from "@/vue/communication/conversation/message/reply/ApplicantIsInterestedToo";
import CustomerNewAppointmentDates from "@/vue/communication/conversation/message/reply/CustomerNewAppointmentDates";
import ApplicantIsInterested from "@/vue/communication/conversation/message/reply/ApplicantIsInterested";
import CustomerPostAppointment from "@/vue/communication/conversation/message/reply/CustomerPostAppointment";
import ApplicantAlternativeAppointmentPossibleForCustomer
	from "@/vue/communication/conversation/message/reply/ApplicantAlternativeAppointmentPossibleForCustomer";
import Collaboration from "@/vue/communication/conversation/message/reply/Collaboration";
import CollaborationAccept from "@/vue/communication/conversation/message/reply/CollaborationAccept";
import MarkAsRead from "@/vue/communication/conversation/message/reply/MarkAsRead";
import Loading from "@/vue/common/Loading";
import InfoBox from "@/vue/common/InfoBox";
import * as ConversationStatus from "@/helper/communication/conversation/Status";
import Get from "@/api/communication/conversation/message/Get";
import _ from "lodash";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/communication/conversation/messages/reply";
import {get} from "@/helper/communication/conversation/message/ApplicantName";
import {scrollToBottom} from "@/helper/Window";
import Button from "@/vue/common/Button.vue";
import {isDefined} from "@/helper/Value";
import JonInfo from "@/vue/common/JonInfo.vue";

const FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_INTERESTED = 'customer-is-interested-interested';
const FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_NOT_INTERESTED = 'customer-is-interested-not-interested';
const FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_CUSTOMER_UNINTERESTING = 'customer-is-interested-customer-uninteresting';

export default {

	components: {
		JonInfo,
		Button,
		Icon,
		ArrowLink,
		Matching,
		PopUp,
		InfoLine,
		CustomerSentAppointmentToApplicant,
		ApplicantPostAppointment,
		CustomerIsInterested,
		ApplicantIsInterestedToo,
		CustomerNewAppointmentDates,
		ApplicantIsInterested,
		CustomerPostAppointment,
		ApplicantAlternativeAppointmentPossibleForCustomer,
		Collaboration,
		CollaborationAccept,
		MarkAsRead,
		Loading,
		InfoBox,
	},

	data ()
	{
		return {
			localMessage: undefined,
			loadingMessage: true,
			loadingMessageUnsuccessful: false,
			conversationStatusList: {
				customerIsInterested: ConversationStatus.CUSTOMER_IS_INTERESTED,
				customerIsInterestedToo: ConversationStatus.CUSTOMER_IS_INTERESTED_TOO,
				applicantIsInterested: ConversationStatus.APPLICANT_IS_INTERESTED,
				applicantIsInterestedToo: ConversationStatus.APPLICANT_IS_INTERESTED_TOO,
				customerSentAppointmentToApplicant: ConversationStatus.CUSTOMER_SENT_APPOINTMENT_TO_APPLICANT,
			},
			loadedMatching: false,
			loadedVita: false,
			loadVita: false,
			footerLayout: undefined,
			customerIsInterestedLoading: false,
			customerIsInterestedSendoffData: undefined,
		};
	},

	computed: {
		...mapState('communication/conversation/messages/reply', [
			'show',
			'title',
			'message',
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
		footerLayouts ()
		{
			return {
				customerIsInterestedInterested: FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_INTERESTED,
				customerIsInterestedNotInterested: FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_NOT_INTERESTED,
				customerIsInterestedCustomerUninteresting: FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_CUSTOMER_UNINTERESTING,
			};
		},
		applicantName ()
		{
			return get(this.localMessage);
		},
		isApplicantIsInterestedToo ()
		{
			return [
				ConversationStatus.APPLICANT_IS_INTERESTED_TOO,
				ConversationStatus.APPLICANT_DECLINED_VITA,
				ConversationStatus.APPLICANT_SENT_VITA,
			].includes(this.localMessage.conversationStatus.id);
		},
		isApplicantDeclinedVita ()
		{
			return [
				ConversationStatus.APPLICANT_DECLINED_VITA,
			].includes(this.localMessage.conversationStatus.id);
		},
		isApplicantSentVita ()
		{
			return [
				ConversationStatus.APPLICANT_SENT_VITA,
			].includes(this.localMessage.conversationStatus.id);
		},
		showCustomerIsInterested()
		{
			if (!this.localMessage)
			{
				return false;
			}

			return [
				ConversationStatus.CUSTOMER_IS_INTERESTED,
				ConversationStatus.CUSTOMER_IS_INTERESTED_TOO
			].includes(this.localMessage.conversationStatus.id);
		},
		customerIsInterestedCustomerUninterestingValid ()
		{
			return isDefined(this.customerIsInterestedSendoffData);
		},
		matchingEligible ()
		{
			return [
				ConversationStatus.CUSTOMER_IS_INTERESTED,
				ConversationStatus.CUSTOMER_IS_INTERESTED_TOO
			].includes(this.localMessage.conversationStatus.id);
		},
		isRecipientTypeApplicant ()
		{
			return this.localMessage.recipientType.applicant;
		},
		isRecipientTypeCustomer ()
		{
			return this.localMessage.recipientType.customer;
		},
		shouldShowCustomerNewAppointmentDates ()
		{
			return this.conversationStatusIsOneOf([
				ConversationStatus.APPLICANT_APPOINTMENT_DATE_COUNTER_PROPOSAL,
				ConversationStatus.APPLICANT_REQUESTED_NEW_APPOINTMENT_DATES,
				ConversationStatus.APPLICANT_DEFERRED_APPOINTMENT,
				ConversationStatus.APPLICANT_WANTS_ALTERNATIVE_APPOINTMENT,
			]);
		},
		shouldShowCustomerSendAppointmentToApplicant ()
		{
			return this.conversationStatusIsOneOf([
				ConversationStatus.CUSTOMER_SENT_APPOINTMENT_TO_APPLICANT,
				ConversationStatus.CUSTOMER_DEFERRED_APPOINTMENT,
				ConversationStatus.FOLLOW_UP_APPOINTMENT,
			]);
		},
		shouldShowCustomerPostAppointment ()
		{
			return this.isRecipientTypeCustomer && this.conversationStatusIsOneOf([
				ConversationStatus.POST_APPOINTMENT,
				ConversationStatus.APPLICANT_INTERESTED_IN_COLLABORATION,
				ConversationStatus.APPLICANT_INTERESTED_IN_COLLABORATION_WANTS_TO_WAIT,
			]);
		},
		customerPostAppointmentForceTookPlace ()
		{
			return this.conversationStatusIsOneOf([
				ConversationStatus.APPLICANT_INTERESTED_IN_COLLABORATION,
			]);
		},
		shouldShowApplicantPostAppointment ()
		{
			return this.isRecipientTypeApplicant && this.conversationStatusIsOneOf([
				ConversationStatus.POST_APPOINTMENT,
			]);
		},
		shouldShowApplicantAlternativeAppointmentPossibleForCustomer ()
		{
			return this.conversationStatusIsOneOf([
				ConversationStatus.ALTERNATIVE_APPOINTMENT_POSSIBLE_FOR_CUSTOMER,
			]);
		},
		shouldShowCollaboration ()
		{
			return this.conversationStatusIsOneOf([
				ConversationStatus.COLLABORATION,
			]);
		},
		shouldShowCollaborationAccept ()
		{
			return this.conversationStatusIsOneOf([
				ConversationStatus.COLLABORATION_ACCEPT,
			]);
		},
	},

	methods: {
		...mapActions('auth', {
			authReload: 'load'
		}),
		...mapActions('communication/conversation/messages/reply', [
			'close'
		]),
		onContentGrow ()
		{
			scrollToBottom(this.$refs.main);
		},
		async loadMessage ()
		{
			this.loadingMessage = true;

			try
			{
				const response = await new Get()
					.setMessageId(this.message.id)
					.call();

				this.localMessage = response.data;
			}
			catch (e)
			{
				this.loadingMessageUnsuccessful = true;
			}

			this.loadingMessage = false;
		},
		onProcessed ()
		{
			this.authReload(); // reload auth to get new message counts, etc.

			this.closeFan({
				processed: true
			});
		},
		closeFan (closeData)
		{
			this.footerLayout = undefined;
			this.close(closeData);
		},
		conversationStatusIsOneOf (statusList)
		{
			return _.includes(
				statusList,
				this.message.conversationStatus.id
			);
		},
		customerIsInterestedClickedInterested()
		{
			this.footerLayout = FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_INTERESTED;

			this.$refs.customerIsInterested.interested();
		},
		customerIsInterestedInterestedRevert ()
		{
			this.footerLayout = undefined;

			this.$refs.customerIsInterested.interestedRevert();
		},
		customerIsInterestedClickedInterestedCustomerUninteresting ()
		{
			this.footerLayout = FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_CUSTOMER_UNINTERESTING;

			this.$refs.customerIsInterested.customerUninteresting();
		},
		customerIsInterestedClickedInterestedCustomerUninterestingRevert ()
		{
			this.footerLayout = FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_INTERESTED;

			this.$refs.customerIsInterested.customerUninterestingRevert();
		},
		customerIsInterestedClickedConfirm ()
		{
			this.$refs.customerIsInterested.sendRequest();
		},
		customerIsInterestedClickedNotInterested ()
		{
			this.footerLayout = FOOTER_LAYOUT__CUSTOMER_IS_INTERESTED_NOT_INTERESTED;

			this.$refs.customerIsInterested.notInterested();
		},
		customerIsInterestedClickedNotInterestedRevert ()
		{
			this.footerLayout = undefined;

			this.$refs.customerIsInterested.notInterestedRevert();
		}
	},

	watch: {
		show (show)
		{
			if (show)
			{
				this.loadMessage();
			}
		}
	}
}
</script>
